import { ClearRounded } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Divider,
	IconButton,
	InputLabel,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import axios from "axios";
import CustomTextField from "components/EboStoreV4/CommonComponents/CustomTextfield/CustomTextfield";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import {
	addOrEditModelAction,
	autoUpdateStoreBasicDetailsData,
	autoUpdatestoreMainFieldsData,
	billerDetailsTableColumns,
	getColDefaultValue,
	leaseDetails,
	storeBasicDetailsFields,
	storeMainFields,
	storesLinkedTables,
	storeTypeDetails,
} from "components/EboStoreV4/data";
import { collectFloorNumber } from "components/EboStoreV4/EboStoresList/CreateNewModal/CreateNewModal";
import { GlobalState } from "context/GlobalContext";
import { arrType, constraintsOptions } from "data/globalData";
import { inputTypes } from "data/pimData";
import { agreementData } from "data/supplierPageData";
import { useEffect, useState } from "react";

const AddOrEditModal = ({ modal, setModal, type, defaultData, handleUpdateDetails, selectedStore, setSelectedStore }) => {
	const defFields = (() => {
		let obj = {};
		storeBasicDetailsFields?.forEach((attr) => {
			obj[attr.key] = getColDefaultValue(attr);
		});
		return obj;
	})();
	const { setSnackBar, snackBar, setSnackBarOpen, loginUser, setLoadingOpen } = GlobalState();
	const [distCustomData, setDistCustomData] = useState([]);
	useEffect(() => {
		getDistriCustomData();
	}, []);

	const getDistriCustomData = async () => {
		try {
			setLoadingOpen(true);
			const res = await axios.get(`/api/ebo_store_v4/get_distributer_customer`);
			console.log(res.data);
			setDistCustomData(res.data);
			setLoadingOpen(false);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Unable to get distributer and customer data",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	const [formData, setFormData] = useState(type === addOrEditModelAction.UPDATE ? defaultData : defFields);

	const handleModalclose = () => {
		setModal(false);
	};

	const handleCallBackFun = () => {
		setSelectedStore({ ...selectedStore, eboStoreBasicDetails: formData });
		setFormData(defFields);
		setModal(false);
	};

	const handleFormSubmit = (e) => {
		e.preventDefault();
		handleUpdateDetails(storesLinkedTables.store_basic_details.seqMethod, formData, handleCallBackFun);
	};

	let distributerData = distCustomData?.filter((row) => row.type === "distributer");
	let customerData = distCustomData?.filter((row) => row.type === "customer");
	let selectedStoreTypeData = selectedStore?.eboStoreTypeDetails[0];

	console.log("selectedStore2345678", formData);
	return (
		<Dialog maxWidth="md" fullWidth open={modal} onClose={handleModalclose} component="form" onSubmit={handleFormSubmit}>
			<Box p={2}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">{type === addOrEditModelAction.UPDATE ? "Update" : "Add"} Store Basic Details</Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Stack spacing={1} width="100%">
					{" "}
					<Box display="flex" columnGap={"10px"} rowGap="10px" flexWrap="wrap" width="100%">
						{storeBasicDetailsFields?.map((row) => {
							let option_data = row.option_data ? row.option_data : {};
							if (row.key === "distributer") {
								option_data = {
									type: arrType,
									list: collectFloorNumber(distributerData, "distributer"),
								};
							}
							if (row.key === "customer") {
								option_data = {
									type: arrType,
									list: collectFloorNumber(customerData, "customer"),
								};
							}
							if (
								(row.key === "customer" || row.key === "distributer") &&
								selectedStoreTypeData["channel"] === "EBO" &&
								!["SELECT", ""].includes(selectedStoreTypeData["store_type"])
							) {
								if (["FOCO", "FOFO"].includes(selectedStoreTypeData["store_type"])) {
									row.constraints.DISPLAY = true;
								} else {
									row.constraints.DISPLAY = false;
								}
							} else if (
								(row.key === "customer" || row.key === "distributer") &&
								selectedStoreTypeData["channel"] !== "EBO"
							) {
								row.constraints.DISPLAY = true;
							}
							return (
								<RenderInputField
									column={{ ...row, option_data }}
									data={formData}
									setData={setFormData}
									width="24%"
									selectOptObjName={"option_data"}
									// dependencyColData={autoUpdateStoreBasicDetailsData}
								/>
							);
						})}
					</Box>
				</Stack>

				<DialogActions sx={{ pt: 2 }}>
					<Button variant="outlined" sx={{ justifySelf: "center" }} onClick={handleModalclose}>
						Cancel
					</Button>
					<Button variant="contained" sx={{ justifySelf: "center" }} type="submit">
						{type === addOrEditModelAction.UPDATE ? "Update" : "Add"}
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default AddOrEditModal;
